module.exports = __webpack_public_path__ + "img/arrow-left.3b868be1.svg";